import config from "@/assets/config";

export const mx_maestros = {
  computed: {},

  methods: {
    getOptions() {
      let headers = this.$store.getters.getHeader;
      return { headers };
    },

    async getFormulariosAdmin() {
      try {
        let url = config.api.url + "plantillas/administracion";
        let response = await this.$axios.get(url, this.getOptions());
        let result = response.data;
        if (result && result.info) {
          return result.info;
        }
      } catch (error) {
        this.$router.push(config.router.home);
      }
    }
  }
};
